import { TicketLocation } from "./services/conversationService";

// Links to one helpdesk ticket: master search by ticket number (KAN-1320) and
// the Communications listing open it on its order's Conversations tab.

/** "TKT-000123" — what master search treats as a ticket number. */
export const TICKET_NUMBER = /^TKT-\d{6}$/i;

/** Query parameters the order page reads to open a ticket on its Conversations tab. */
export const CONVERSATION_TAB_PARAM = "tab";
export const CONVERSATION_TAB_VALUE = "conversations";
export const TICKET_PARAM = "ticket";

/** The order page with the ticket open, or the Communications ticket screen when it has no order. */
export const ticketPath = ({ orderId, ticketId }: Pick<TicketLocation, "orderId" | "ticketId">) =>
  orderId
    ? `/all-orders/${orderId}?${CONVERSATION_TAB_PARAM}=${CONVERSATION_TAB_VALUE}&${TICKET_PARAM}=${encodeURIComponent(ticketId)}`
    : `/communications/unassigned/${encodeURIComponent(ticketId)}`;
